/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, BOURBON_US){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/us/common/svg/sprite.svg#arrow_left2" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/us/common/svg/sprite.svg#arrow_right2" /></svg></button>';

	// <商品詳細>商品画像スライド
	const brandDetailSlider = () => {
		// 2～3枚目画像がない場合は非表示
		$('.brand-detail-slider-img').each((idx,ele) => {
			if(!$(ele).find('img').length) {
				$(ele).parents('li').remove();
			}
		});

		$('.brand-detail-slider').slick({
			infinite: true,
			speed: 1500,
			// autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			arrows: false,
			dots: true,
			customPaging: function(slick, index){
				let targetImage = slick.$slides.eq(index).find('img').attr('src');
				let targetImageAlt = slick.$slides.eq(index).find('img').attr('alt');
				return '<img src="'+ targetImage +'" alt="'+ targetImageAlt +'"/>';
			},
			responsive: [
				{
					breakpoint: 768,
					settings: {
						customPaging: function(slick, index){
							return false;
						}
					}
				}
			]
		});

	};

	if($('.brand-detail-slider').length) {
		brandDetailSlider();
	}

})(window.jQuery, window.BOURBON_US);
